// スマホ時のヘッダードロワー

let isOpened = false

function open () {
	if (isOpened) {
		return
	}
	isOpened = true
	document.querySelector('.header__sm-drawer').classList.add('is--opened')
}

function close () {
	if (!isOpened) {
		return
	}
	isOpened = false
	document.querySelector('.header__sm-drawer').classList.remove('is--opened')
}

function toggle () {
	if (isOpened) {
		close()
	} else {
		open()
	}
}

export default function headerDrawer () {
	const btn = document.querySelector('.header__sm-drawer-btn')
	const drawer = document.querySelector('.header__sm-drawer')
	if (btn && drawer) {
		btn.addEventListener('click', toggle)
		drawer.addEventListener('click', close)
	}
	return {open, close, toggle}
}
